import React from 'react'
import { useTranslation } from 'react-i18next'
import Tip from '../../../../../components/tip/Tip'

export default function HighlightTips() {
  const [t] = useTranslation()

  return (
    <>
      <Tip
        overline={t('editHighlight.highlightTips.item1Overline', 'Instructions')}
        primaryText={t('editHighlight.highlightTips.item1PrimaryText', 'Adding and removing highlights')}
        listPrimaryText={
          <>
            <p>
              {t(
                'editHighlight.highlightTips.item1Content',
                'To add a highlight, hover over the correct name on the image. If a blue highlight appears, select it and then attach.'
              )}
            </p>
            <p>
              {t(
                'editHighlight.highlightTips.item1Content2',
                'To remove a highlight, hover over an existing yellow highlight and select it and then detach.'
              )}
            </p>
          </>
        }
      />
      <Tip
        primaryText={t('editHighlight.highlightTips.item2PrimaryText', "Don't see a blue highlight?")}
        listPrimaryText={t(
          'editHighlight.highlightTips.item2Content',
          'If no blue highlight appears, you will create a new one.'
        )}
      />
    </>
  )
}
